var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright d-flex flex-column align-items-end"},[_vm._v(" © "+_vm._s(_vm.year)+" gurunews ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }